import { SvrAPk } from "../../utils/axios";
/**
 * metodo para traer las areas
 */
export const getAreas = async () => {
  let res = {};
  try {
    res = await SvrAPk.get("/api/public/area/getarea");
  } catch (Error) {
    res = Error;
  }
  return res;
};
/**
 *  Metodo para Traer un area especifica
 */
export const getAreaInt = async (AreaId) => {
  let res = {};
  try {
    res = await SvrAPk.post("/api/public/area/getareaint", {
      AreaId,
    });
  } catch (Error) {
    res = Error;
  }
  return res;
};
/**
 *  Metodo para Traer los mensajes de un area
 */
export const getMensajexArea = async (AreaId) => {
  let res = {};
  try {
    res = await SvrAPk.post("/api/public/area/getmensajesarea", {
      AreaId,
    });
  } catch (Error) {
    res = Error;
  }
  return res;
};
